import React from "react";
import { useIntl } from "react-intl";

import CustomSelect from "src/app/components/CustomSelect/CustomSelect";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";
import getAges from "./utils/getAges";

export default function InfluencerAgeRangeSelect({
  influencerAgeFrom,
  influencerAgeTo,
  onChangeInfluencerAgeFrom,
  onChangeInfluencerAgeTo,
  isDisabled,
}) {
  const intl = useIntl();

  const influencerAgeFromOptions = getAges("from", influencerAgeTo);
  const influencerAgeToOptions = getAges("to", influencerAgeFrom);

  const foundInfluencerAgeFromOption =
    influencerAgeFromOptions.find(
      (item) => item.value === Number(influencerAgeFrom?.value),
    ) ?? null;
  const foundInfluencerAgeToOption =
    influencerAgeToOptions.find(
      (item) => item.value === Number(influencerAgeTo?.value),
    ) ?? null;

  return (
    <div className="audience-search__field" data-qa="filter_influencer_age">
      <div className="audience-search__field-columns">
        <div className="audience-search__field-col-1">
          <div className="idh-label idh-label--with-tooltip">
            <IDHFormattedMessage id="front_age" defaultMessage="Age" />
            <MaterialTooltip
              id="front_influencer_age_tooltip"
              content={
                <IDHFormattedMessage
                  id="front_influencer_age_tooltip"
                  defaultMessage="Here, you can specify the influencer’s age.  "
                />
              }
            />
          </div>
          <CustomSelect
            placeholder={intl.formatMessage({
              id: "front_select_age_from",
              defaultMessage: "Select",
            })}
            isClearable
            value={foundInfluencerAgeFromOption}
            options={influencerAgeFromOptions}
            onChange={(option) => {
              if (option) {
                onChangeInfluencerAgeFrom({ value: option.value });
              } else {
                onChangeInfluencerAgeFrom(option);
              }
            }}
            isDisabled={isDisabled}
            dataAttr="influencer-age-from"
          />
        </div>
        <div className="audience-search__field-col-1">
          <div className="idh-label">
            <IDHFormattedMessage id="front_to" defaultMessage="To" />
          </div>
          <CustomSelect
            placeholder={intl.formatMessage({
              id: "front_select_age_to",
              defaultMessage: "Select",
            })}
            isClearable
            value={foundInfluencerAgeToOption}
            options={influencerAgeToOptions}
            onChange={(option) => {
              if (option) {
                onChangeInfluencerAgeTo({ value: option.value });
              } else {
                onChangeInfluencerAgeTo(option);
              }
            }}
            isDisabled={isDisabled}
            dataAttr="influencer-age-to"
          />
        </div>
      </div>
    </div>
  );
}
